import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetTransactionsDictionariesQuery,
  useLazyGetTransactionsBaseCurrencyQuery,
  useLazyGetTransactionsCurrenciesQuery,
  useLazyGetTransactionsCountriesQuery,
} from '../../store/dictionaries/services';
import GeneralLedgerList from './list';

import cn from './styles.module.css';

const GeneralLedger = (): React.JSX.Element => {
  const [getDictionaries] = useLazyGetTransactionsDictionariesQuery();
  const [getTransactionBaseCurrency] =
    useLazyGetTransactionsBaseCurrencyQuery();
  const [getTransactionCurrencies] = useLazyGetTransactionsCurrenciesQuery();
  const [getTransactionCountries] = useLazyGetTransactionsCountriesQuery();

  const {
    activePermissions,
    transactionsTypes,
    countries,
    currencies,
    baseCurrency,
  } = useAppSelector((state) => state.transactionsDictionaries);

  const { values: transactionsTypesSettings } = useAppSelector(
    (state) => state.settings.transactionsTypes,
  );

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(
        PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_LIST,
      )
    ) {
      if (!transactionsTypes) {
        getDictionaries();
      }

      if (!currencies) {
        getTransactionCurrencies();
      }

      if (!countries) {
        getTransactionCountries();
      }

      if (!baseCurrency) {
        getTransactionBaseCurrency();
      }
    }
  }, [
    activePermissions,
    baseCurrency,
    currencies,
    countries,
    transactionsTypes,
  ]);

  useEffect(() => {
    let title = 'General ledger transactions';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.generalLedgerLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions && transactionsTypesSettings) {
    if (
      activePermissions.includes(
        PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_LIST,
      ) &&
      transactionsTypesSettings?.find((item) => item.name === 'GENERAL_LEDGER')
        ?.active
    ) {
      content = (
        <div className={cn.generalLedger}>
          <GeneralLedgerList />
          <Outlet />
        </div>
      );
    } else {
      content = <PermissionDenied />;
    }
  }

  return content;
};

export default GeneralLedger;
